














import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { ConsultoresService } from "@/services/consultores.service";
import { date, dateTime, timeFromNow } from "@/shared/filters";

@Component({
  components: {
    DataTable,
  },
  filters: { date, dateTime, timeFromNow },
})
export default class UltimosAcessos extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  promiseAcessos: Promise<any[]> | null = null;
  loading = false;

  headersAcessos = [
    { value: "ultimoAcesso", text: "Último acesso" },
    { value: "acessos", text: "Acessos" },
    { value: "ip", text: "IP" },
    { value: "clientId", text: "Client" },
  ];

  mounted() {
    this.fetchUltimosAcessos(this.idConsultor);
  }

  async fetchUltimosAcessos(idConsultor: number) {
    this.loading = true;
    try {
      this.promiseAcessos = await ConsultoresService.ListarAcessos(
        idConsultor,
        10
      );
    } finally {
      this.loading = false;
    }
  }
}
